import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import "../../assets/styles/local/SpireConnect.css";
import Header from "../../layouts/Header";
import spireBlackLogo from "../../assets/icons/spireBlackLogo.svg";
import Google_G_Logo from "../../assets/icons/Google_G_Logo.svg";
import MicroSoft365 from "../../assets/icons/MicroSoft365.svg";
import Intuit_QuickBooks_logo from "../../assets/icons/Intuit_QuickBooks_logo.svg";
import LinkIcon from "../../assets/icons/Link.svg";
import Loader from "../../components/Dailogs/Loader";
import GoogleAuthButton from "../../components/Google/google-auth-button";
import { OutlookAuthBtn, outlookLogin } from "./OutlookAuthButton";
import SpireConnectPopup from "../../components/Dailogs/SpireConnectPopup";
import { API_URL, EXACT_ONLINE_AUTH_URL } from "../../redux/constants/type";

import {
  FetchUserIntegration,
  syncToQuickBooks,
  SetQuickBookConnection,
} from "../../redux/actions/action";
import { axiosInstance } from "../../redux/constants/axiosInstance";
import { useDispatch, useSelector } from "react-redux";

import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Attention from "../../assets/icons/Attention.svg";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import {
  disconnectGoogleIntegration,
  disconnectOutlookIntegration,
} from "../../redux/constants/integrationApi";
import { handleGeneralNotification } from "../../utils/helpers/notifications";

const SpireConnect = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const googleAuthRef = useRef(null);

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Spire-Connect").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const fetchIntergrationRes = useSelector(
    (state) => state.user.fetchIntergrationRes,
  );

  const qbSyncStatus = useSelector((state) => state.user.qbSyncStatus);
  const qbSyncResponse = useSelector((state) => state.user.qbSyncResponse);

  // variables state management start
  const [spirePopupShow, setSpirePopupShow] = useState(false);
  const [userIntegrationData, setUserIntegrationData] = useState([]);
  const [integrationID, setIntegrationID] = useState("");
  const [dynamicContent, setDynamicContent] = useState("");
  const [dynamicButtonText, setDynamicButtonText] = useState("");
  const [spireConnectProfileText, setSpireConnectProfileText] = useState("");
  const [authBtnShow, setAuthBtnShow] = useState("");
  const [eoCode, setEoCode] = useState("");
  const [spireConnectFunction, setSpireConnectFunction] = useState(() => {});
  const [popupAction, setPopupAction] = useState("");
  const [popupLoading, setPopupLoading] = useState(false);

  useEffect(() => {
    const handleOAuthCallback = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get("code");
      const state = params.get("state");
      const status = params.get("status");
      const provider = params.get("provider");
      const from = params.get("from");
      const authorizationCode = `${code}`;

      if (status === "connected") {
        if (provider === "Google" && from) {
          window.localStorage.setItem("googleEmail", from);
        }
        if (provider === "Outlook" && from) {
          window.localStorage.setItem("outlookEmail", from);
        }

        params.delete("status");
        params.delete("provider");
        params.delete("from");
        if (provider === "Google") {
          handleRefresh("Google workspace");
        }

        if (provider === "Outlook") {
          handleRefresh("Microsoft Office 365");
        }
        history.replace({
          pathname: location.pathname,
          search: params.toString() ? `?${params.toString()}` : "",
        });
        return;
      }

      if (state === "outlook" && code) {
        history.replace("/spire-connect");
        return;
      }

      if (code) {
        axiosInstance
          .post(`${API_URL}/api/User/IntegrationSettings/AddExactOnlineToken`, {
            integrationToken: code,
            tokenValidity: "",
            tokenExpiryDate: new Date().toLocaleString(),
          })
          .then((res) => {
            console.log(res);
            handleRefresh("Exact");
            history.replace("/spire-connect");
          })
          .catch((error) => {
            console.error("Exact Online integration failed:", error);
          });
      }

      dispatch(FetchUserIntegration());
    };

    handleOAuthCallback();
  }, []);

  useEffect(() => {
    if (fetchIntergrationRes.status === true) {
      // fetchIntergrationRes.data = [
      //   ...fetchIntergrationRes.data,
      //   {
      //     userId: "08dae7e6-231a-4741-84d2-7931ed38fc7b",
      //     integrationId: "08dcbbb8-80a8-44c9-86ae-e713ad987005",
      //     integrationName: "Exact Online",
      //     integrationLogo: "assets/icons/exact.svg",
      //     isactive: 1,
      //     token: "",
      //     tokenValidity: "",
      //     integrationStatus: "InActive",
      //     tokenExpirationDate: "2025-12-12T12:52:04",
      //   },
      // ];
      setUserIntegrationData(fetchIntergrationRes.data);
    }
  }, [fetchIntergrationRes]);

  const [qbShowActive, setQbShowActive] = useState("Inactive");
  console.log("asc qbShowActive", qbShowActive);

  useEffect(() => {
    if (qbSyncStatus) {
      console.log("asc qb status", qbSyncStatus.status);
    }
  }, [qbSyncStatus]);

  useEffect(() => {
    if (qbSyncResponse) {
      if (qbSyncResponse?.status === true) {
        setQbShowActive("Active");
      } else if (qbSyncResponse?.status === false) {
        setQbShowActive("Error");
      }
      console.log("asc qb responce", qbSyncResponse.status);
    }
  }, [qbSyncResponse]);

  const handleCheckboxChange = (item, event) => {
    const isChecked = event.target.checked;

    console.log(isChecked);
    if (!isChecked && item.integrationName === "Google workspace") {
      setPopupAction("disconnectGoogle");
      setDynamicContent(
        <div className="dynamicContentTxt">
          Are you sure you want to disconnect Google Workspace?
          <p className="pt-2">
            This will remove the Google account connection for email sync.
          </p>
        </div>,
      );
      setDynamicButtonText("Disconnect");
      setSpirePopupShow(true);
      return;
    }

    if (!isChecked && item.integrationName === "Microsoft Office 365") {
      setPopupAction("disconnectOutlook");
      setDynamicContent(
        <div className="dynamicContentTxt">
          Are you sure you want to disconnect Microsoft Office 365?
          <p className="pt-2">
            This will remove the Outlook account connection for email sync.
          </p>
        </div>,
      );
      setDynamicButtonText("Disconnect");
      setSpirePopupShow(true);
      return;
    }

    if (isChecked) {
      setPopupAction("");
      setSpirePopupShow(true);
      // Set dynamic content based on the integration name
      if (item.integrationId === "08dcbbb8-80a8-44c9-86ae-e713ad987007") {
        setDynamicContent(
          <div className="dynamicContentTxt">
            Thank you for choosing to connect with Exact Online.
            <p>
              We will set up the connection and notify you when is finished.
            </p>
            <p className="pt-2">
              You’ll receive the instructions to access Exact Online from Spire
              Essentials on your email.
            </p>
          </div>,
        );
        setDynamicButtonText("Connect");
        setSpireConnectProfileText("Connect with Exact Online");
        setIntegrationID(item.integrationId);
      } else if (item.integrationName === "Quickbook Online") {
        // setDynamicContent(
        //   "it will work Direct in string, or we can do it in Div👇"
        // );
        setDynamicContent(
          <div className="dynamicContentTxt">
            Thank you for choosing to connect with Quickbooks.
            <p>
              We will set up the connection and notify you when is finished.
            </p>
            <p className="pt-2">
              You’ll receive the instructions to access Quickbooks from Spire
              Essentials on your email.
            </p>
          </div>,
        );
        setDynamicButtonText("Ok");
        setIntegrationID(item.integrationId);
      } else if (item.integrationName === "Google workspace") {
        setDynamicContent(
          <div className="dynamicContentTxt">
            Thank you for choosing to connect with Google Workspace.
            <p>
              The connection is now active for your organization and co-Workers.
            </p>
            <p className="pt-2">
              All the Co-workers have to establish the connection on profile
              with their account.
            </p>
          </div>,
        );
        setDynamicButtonText("Go to Profile");
        setSpireConnectProfileText("Connect with Google account");

        // Set specific action for Google Accounts.
        setSpireConnectFunction(() => () => {
          // history.push("/dashboard");
        });
      } else if (item.integrationName === "Microsoft Office 365") {
        setDynamicContent(
          <div className="dynamicContentTxt">
            Thank you for choosing to connect with Microsoft Office 365.
            <p>
              The connection is now active for your organization and co-Workers.
            </p>
            <p className="pt-2">
              All the Co-workers have to establish the connection on profile
              with their account.
            </p>
          </div>,
        );
        setDynamicButtonText("Go to Profile");
        setSpireConnectProfileText("Connect with Microsoft account");

        // Set specific action for Microsoft Accounts
        setSpireConnectFunction(() => () => {
          outlookLogin();
        });
      } else {
        setDynamicContent("You have selected Spire Connect integration.");
        setDynamicButtonText("Spire Connect");
        setSpireConnectProfileText("");
      }
    }

    // else {
    //   setDynamicContent(
    //     <div className="dynamicContentTxt">
    //       Sorry, to disable already activated integrations can have huge impact on the business operations, <br />
    //       and the stability of your system. Please contact you local MSP or implementation partner to get it done.
    //     </div>
    //   );

    //   setDynamicButtonText("Ok");
    // }
  };

  const closeSpirePopup = () => {
    if (popupLoading) {
      return;
    }

    setSpirePopupShow(false);
    setPopupAction("");
  };

  const handleDelete = async () => {
    if (popupLoading) {
      return;
    }

    if (popupAction === "disconnectGoogle") {
      try {
        setPopupLoading(true);
        await disconnectGoogleIntegration();
        window.localStorage.removeItem("googleEmail");
        setSpirePopupShow(false);
        setPopupAction("");
        handleRefresh();
      } catch (error) {
        console.error("Google disconnect failed:", error);
        setDynamicContent(
          <div className="dynamicContentTxt">
            Unable to disconnect Google Workspace.
            <p className="pt-2">
              Please try again, or contact support if the issue continues.
            </p>
          </div>,
        );
      } finally {
        setPopupLoading(false);
      }

      return;
    }

    if (popupAction === "disconnectOutlook") {
      try {
        setPopupLoading(true);
        await disconnectOutlookIntegration();
        window.localStorage.removeItem("outlookEmail");
        setSpirePopupShow(false);
        setPopupAction("");
        handleRefresh();
      } catch (error) {
        console.error("Outlook disconnect failed:", error);
        setDynamicContent(
          <div className="dynamicContentTxt">
            Unable to disconnect Microsoft Office 365.
            <p className="pt-2">
              Please try again, or contact support if the issue continues.
            </p>
          </div>,
        );
      } finally {
        setPopupLoading(false);
      }

      return;
    }

    setSpirePopupShow(false);
    if (dynamicButtonText === "Connect") {
      window.location = EXACT_ONLINE_AUTH_URL;
    } else if (dynamicButtonText === "Ok") {
      axiosInstance
        .post(`${API_URL}/api/User/IntegrationSettings/AddQuickBookToken`, {
          integrationToken: "",
          tokenValidity: "",
          tokenExpiryDate: new Date().toLocaleString(),
        })
        .then((res) => {
          console.log(res);
          handleRefresh("Quickbook Online");
        });

      setQbShowActive("Waiting");
    } else if (
      spireConnectProfileText === "Connect with Google account" ||
      spireConnectProfileText === "Connect with Microsoft account"
    ) {
      setTimeout(() => {
        // Trigger a click event on the element with the class 'fas fa-bars'.
        const targetElement = document.querySelector(".profileButton");
        console.log("asc44", targetElement);
        if (targetElement) {
          targetElement.click(); // Simulate a click event.
        } else {
          console.log('Element with class "profileButton" not found.');
        }
      }, 500);
    } else if (dynamicButtonText === "Spire Connect") {
      window.open("https://basic_dev_api.spire.solutions/swagger/index.html");
    }
  };

  const handleRefresh_old = () => {
    dispatch(FetchUserIntegration()).then((res) => {
      console.log("asccx", res);
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: ``,
        },
        false,
      );
    });
  };

  const handleRefresh = (integrationName) => {
    dispatch(FetchUserIntegration()).then((res) => {
      console.log("asccx", res);

      const integration = res?.data?.find(
        (item) => item.integrationName === integrationName,
      );

      if (!integration) return;

      if (integration.integrationStatus === "Active") {
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: `${integration.integrationName} connected successfully.`,
          },
          false,
        );
      }

      if (integration.integrationStatus === "InActive") {
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: `${integration.integrationName} is InActive.`,
          },
          false,
        );
      }
    });
  };

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#FFFFFF",
      color: "rgba(0, 0, 0, 0.87)",
      width: theme.typography.pxToRem(500),
      height: theme.typography.pxToRem(100),
      fontSize: theme.typography.pxToRem(12),
      fontSize: 12,
      boxShadow: theme.shadows[2],
    },
  }));

  return (
    <>
      <Header
        // setQuery={setQuerystring}
        SpireConnectConnection={
          spireConnectProfileText !== "" && (
            <div
              className="d-flex gap-3 ps-4 py-3 position-relative connectTxt"
              onClick={spireConnectFunction}
              style={{ cursor: "pointer" }}
            >
              <img alt="" src={LinkIcon} />
              <p className="mb-0">{spireConnectProfileText}</p>

              <div className="pointer">
                {spireConnectProfileText === "Connect with Google account" ? (
                  <div className="googleAuth">
                    <GoogleAuthButton handleRefresh={handleRefresh} />
                  </div>
                ) : spireConnectProfileText ===
                  "Connect with Microsoft account" ? null : (
                  ""
                )}
              </div>
            </div>
          )
        }
        leftComponent={
          <div className="d-flex align-items-baseline flex-wrap gap-4">
            <div
              className="settingText"
              onClick={() => {
                history.push("/settings");
              }}
            >
              {/* Settings */}
              {t("Settings ")}
            </div>
            <div className="pt-2 d-flex pe-3" style={{ background: "#FFFFFF" }}>
              <p className="pt-1 ps-4 myplanTxt">
                {/* Spire Connect */}
                {t("Spire Connect ")}
              </p>
              {/* <p className="pt-1 projectID ps-5"> &nbsp;{invoiceId} </p> */}
            </div>
          </div>
        }
      />

      {spirePopupShow && (
        <SpireConnectPopup
          animation={true}
          show={spirePopupShow}
          handleDelete={handleDelete}
          onHide={closeSpirePopup}
          backdrop="static"
          DynamicContent={dynamicContent}
          DynamicButtonText={dynamicButtonText}
          loading={popupLoading}
        />
      )}

      <div className="">
        <div className="d-flex flex-wrap gap-3 justify-content-end pt-2 pe-2">
          <button
            className="mb-0 ms-md-auto cancelBtn ascButton"
            // onClick={() => {
            //   if (typeInScreen !== "") {
            //     setCancelPopupShow(true);
            //   } else {
            //     history.goBack();
            //     // history.push("/InvoiceAllList");
            //   }
            // }}

            onClick={() => {
              history.goBack();
            }}
          >
            {/* Cancel */}
            {t("Cancel")}
          </button>

          <button
            className="mb-0 makeInvoBtn ascButton"
            onClick={() => {
              //   asc;
            }}
          >
            {/* Change */}
            {t("Change")}
          </button>
        </div>

        <div className="SpireDiv m-5">
          <div className="ascTableWrapper mt-3 px-4">
            <table className="table">
              <thead>
                <tr
                  className="tableHeading"
                  style={{
                    color: "#323232",
                    fontSize: "16px",
                    fontWeight: "700",
                    borderBottom: "0.5px dotted",
                  }}
                >
                  <th style={{ width: "10%" }}>
                    {/* Select to integrate with */}
                    {t("Select to integrate with ")}
                  </th>
                  <th style={{ width: "67%" }}></th>
                </tr>
              </thead>

              <tbody
                className="tabLine"
                style={{
                  color: "#323232",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {userIntegrationData
                  // .slice(currentPage * perPage, (currentPage + 1) * perPage)
                  .map((item, index) => {
                    return (
                      <tr className="asc_Table_Hover fw-normal">
                        <td className="py-3">
                          <div className="d-flex gap-4">
                            {item.integrationStatus === "Active" &&
                              item.integrationName !== "Microsoft Office 365" &&
                              item.integrationName !== "Google workspace" && (
                                <HtmlTooltip
                                  placement="top"
                                  title={
                                    <React.Fragment>
                                      <div>
                                        Sorry, to disable already activated
                                        integrations can have huge impact on the
                                        business operations, and the stability
                                        of your system. Please contact you local
                                        MSP or implementation partner to get it
                                        done.
                                      </div>
                                    </React.Fragment>
                                  }
                                >
                                  <input
                                    id={item.integrationId}
                                    type="checkbox"
                                    checked={
                                      item.integrationStatus === "Active"
                                    }
                                    className="form-check-input pointer companyRadio ms-"
                                    onChange={(event) => {
                                      handleCheckboxChange(item, event);
                                    }}
                                  />
                                </HtmlTooltip>
                              )}
                            {(item.integrationStatus !== "Active" ||
                              item.integrationName === "Microsoft Office 365" ||
                              item.integrationName === "Google workspace") && (
                              <input
                                id={item.integrationId}
                                type="checkbox"
                                checked={item.integrationStatus === "Active"}
                                className="form-check-input pointer companyRadio ms-"
                                onChange={(event) => {
                                  handleCheckboxChange(item, event);
                                }}
                              />
                            )}
                            <label
                              className="d-flex gap-1"
                              for={item.integrationId}
                            >
                              {/* <img src={spireBlackLogo} alt="" /> */}
                              {/* {item.integrationName} */}
                              {
                                <img
                                  alt=""
                                  className="integration-logo"
                                  src={item.integrationLogo}
                                />
                              }
                            </label>
                          </div>
                        </td>

                        <td className="py-3">
                          ┃ &nbsp; &nbsp; &nbsp; &nbsp;
                          {item.integrationName}
                        </td>

                        <td className="ms-auto pointer py-3">
                          <div className="d-flex">
                            <p
                              className="mb-0 text-center pt-1 cancelBtn ascButton"
                              style={{
                                height: "30px",
                                background: "#F1F1F1",
                                paddingTop: "3px",
                                fontSize: "12px",
                                color:
                                  item.integrationStatus === "Active"
                                    ? "#00246a"
                                    : "#323232",
                              }}
                              onClick={() => {
                                //   asc;
                              }}
                            >
                              {item.integrationStatus}
                            </p>
                            <label style={{ padding: "4px", color: "green" }}>
                              &nbsp;{item.tokenValidity}
                            </label>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                {userIntegrationData.length === 0 && (
                  <span className="noDataDisplay">
                    No data to display!
                    {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                  </span>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpireConnect;
